export const ADDRESS_LIST = "ADDRESS_LIST";
export const SAVE_USER_PROFILE = "SAVE_USER_PROFILE";
export const REMOVE_USER_PROFILE = "REMOVE_USER_PROFILE";
export const FAV_MENU_ITEM = "FAV_MENU_ITEM";
export const REMOVE_FAV_MENU_ITEM = "REMOVE_FAV_MENU_ITEM";
export const ADD_GUEST = "ADD_GUEST";
export const REMOVE_GUEST = "REMOVE_GUEST";
export const GET_PROFILE = "GET_PROFILE"
export const LOG_IN = "LOG_IN"
export const LOG_OUT = "LOG_OUT"
export const REMOVE_ORDER_LIST = "REMOVE_ORDER_LIST"
export const SOCIAL_LOG_OUT = "SOCIAL_LOG_OUT"
export const SOCIAL_LOG_IN = "SOCIAL_LOG_IN"
export const SAVE_USER_CARD_DETAILS = "SAVE_USER_CARD_DETAILS"
export const MOB_SAVE_USER_CARD_DETAILS = "MOB_SAVE_USER_CARD_DETAILS"
export const ORDER_TYPES = "ORDER_TYPES"

